module.exports = __webpack_public_path__ + "static/media/noho-logo.1398def2.png";